// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * One named value of an enum argument.
 */
export class DeclaredEnumMember implements flatbuffers.IUnpackableObject<DeclaredEnumMemberT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): DeclaredEnumMember {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsDeclaredEnumMember(
    bb: flatbuffers.ByteBuffer,
    obj?: DeclaredEnumMember,
  ): DeclaredEnumMember {
    return (obj || new DeclaredEnumMember()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsDeclaredEnumMember(
    bb: flatbuffers.ByteBuffer,
    obj?: DeclaredEnumMember,
  ): DeclaredEnumMember {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new DeclaredEnumMember()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  value(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  static startDeclaredEnumMember(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nameOffset, 0);
  }

  static addValue(builder: flatbuffers.Builder, value: bigint) {
    builder.addFieldInt64(1, value, 0n);
  }

  static endDeclaredEnumMember(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createDeclaredEnumMember(
    builder: flatbuffers.Builder,
    nameOffset: flatbuffers.Offset,
    value: bigint,
  ): flatbuffers.Offset {
    DeclaredEnumMember.startDeclaredEnumMember(builder);
    DeclaredEnumMember.addName(builder, nameOffset);
    DeclaredEnumMember.addValue(builder, value);
    return DeclaredEnumMember.endDeclaredEnumMember(builder);
  }

  unpack(): DeclaredEnumMemberT {
    return new DeclaredEnumMemberT(this.name(), this.value());
  }

  unpackTo(_o: DeclaredEnumMemberT): void {
    _o.name = this.name();
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): DeclaredEnumMemberT {
    const t = new DeclaredEnumMemberT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class DeclaredEnumMemberT implements flatbuffers.IGeneratedObject {
  constructor(
    public name: string | Uint8Array | null = null,
    public value: bigint = 0n,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const name = this.name !== null ? builder.createString(this.name!) : 0;

    return DeclaredEnumMember.createDeclaredEnumMember(builder, name, this.value);
  }

  clone(): DeclaredEnumMemberT {
    const obj = new DeclaredEnumMemberT();
    obj.name = this.name;
    obj.value = this.value;
    return obj;
  }

  equals(other: DeclaredEnumMemberT): boolean {
    if (this.name !== other.name) return false;
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyDeclaredEnumMember(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 6, 8);
  } finally {
    verifier.popDepth();
  }
}
